import { type FC } from "react";

import { colorByPlatform } from "~/feature/chart/constants";
import type { IMarket } from "~/types/event";

import * as Styled from "./PlatformDots.styles";

interface IPlatformDotsProps {
  markets: IMarket[];
}

export const PlatformDots: FC<IPlatformDotsProps> = ({ markets }) => {
  return (
    <Styled.Root>
      {markets.map(({ id, platform }) => (
        <Styled.Dot key={id} $color={colorByPlatform[platform]} />
      ))}
    </Styled.Root>
  );
};
